import { FormGroup } from '@mui/material';
import React, { ComponentProps } from 'react';
import { SwitchLabel, Switch, SwitchFormControlLabel } from './styles';

export const ShowHideDecimalToggle = ({
  showDecimals,
  toggleShowDecimals,
  labelPlacement = 'top',
  testingId,
}: {
  showDecimals: boolean;
  toggleShowDecimals: (e: React.ChangeEvent) => void;
  labelPlacement?: ComponentProps<
    typeof SwitchFormControlLabel
  >['labelPlacement'];
  testingId?: string;
}) =>
  window.SPWExport ? null : (
    <FormGroup aria-label="position" row>
      <SwitchFormControlLabel
        data-testid={testingId}
        value={labelPlacement}
        control={
          <Switch
            checked={showDecimals}
            onChange={toggleShowDecimals}
            color="default"
          />
        }
        label={<SwitchLabel>Decimals</SwitchLabel>}
        labelPlacement={labelPlacement}
      />
    </FormGroup>
  );
